/** /welcome (OutlierOS replica): checklist + two explainers. */
import { BRAND } from '@vw/core/src/brand';
import { OnboardingChecklist } from '../components/OnboardingChecklist';
import { Link } from '../router';

export function Welcome() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="text-3xl font-black tracking-tight">Welcome to {BRAND.name} 👋</h1>
        <p className="mt-1 text-sm text-muted-foreground">Four quick steps to your first Wise Score. Steps tick themselves off as you go.</p>
      </div>
      <OnboardingChecklist variant="page" />
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-border bg-card p-5">
          <h2 className="font-bold">What's a Wise Score?</h2>
          <p className="mt-1 text-sm text-muted-foreground">How a reel did against the creator's normal: views ÷ their usual views (the median of their recent reels). A Wise Score of 3× or more means the reel broke out (⚡ Hot); 5× is 🔥 Viral and 10× is 🚀 Legendary.</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <h2 className="font-bold">Need help?</h2>
          <p className="mt-1 text-sm text-muted-foreground">Email <a className="font-semibold text-primary" href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</a>.</p>
        </div>
      </div>
      <Link to="/feed" className="inline-block text-sm font-semibold text-primary">Skip to my feed →</Link>
    </div>
  );
}
